import React from "react";
import CustomText from "../components/common/general/CustomText/CustomText";
import { MotiView } from "moti";
import StudentInsights from "../components/analytics/StudentInsights/StudentInsights";
import {
  useGetStudentLearningInsightsQuery,
  useGetStudentDetailedAnalyticsQuery,
  useGetStudentChatAnalyticsQuery,
} from "../graphql/generated/graphql";
import DefaultLayout from "../layouts/DefaultLayout.web";
import { useAppConfig } from "../AppConfigProvider";
import { useAuth } from "../hooks/useAuth";

const InsightsView = () => {
  const appConfig = useAppConfig();
  const schoolId = appConfig.axioSchools[0];

  const { userInfo } = useAuth();

  const { data: insightsData, loading: insightsLoading } = useGetStudentLearningInsightsQuery({
    variables: { schoolId, studentId: userInfo.userId },
    skip: !schoolId || !userInfo.userId,
  });

  const { data: detailedData, loading: detailedLoading } = useGetStudentDetailedAnalyticsQuery({
    variables: { schoolId, studentId: userInfo.userId },
    skip: !schoolId || !userInfo.userId,
  });

  const { data: chatData, loading: chatLoading } = useGetStudentChatAnalyticsQuery({
    variables: { schoolId, studentId: userInfo.userId },
    skip: !schoolId || !userInfo.userId,
  });

  // Combine all data into a single object for StudentInsights component
  const combinedData = {
    getStudentDetailedAnalytics: detailedData?.getStudentDetailedAnalytics,
    getStudentLearningInsights: insightsData?.getStudentLearningInsights,
    getStudentChatAnalytics: chatData?.getStudentChatAnalytics,
  };

  const isLoading = insightsLoading || detailedLoading || chatLoading;

  return (
    <DefaultLayout pageHasChat={false}>
      <MotiView
        from={{ opacity: 0, translateY: 20 }}
        animate={{ opacity: 1, translateY: 0 }}
        delay={10}
        // @ts-expect-error - transition is not typed
        transition={{ type: "timing", duration: 500 }}>
        <CustomText useTranslationText={false} textType="display" text="Insights" size="m" weight="ultraBold" />
      </MotiView>

      {isLoading ? (
        <CustomText
          useTranslationText={false}
          textType="text"
          text="Loading insights..."
          size="m"
          style={{ marginTop: 48 }}
        />
      ) : (
        <StudentInsights data={combinedData} />
      )}
    </DefaultLayout>
  );
};

export default InsightsView;
